import web from '../web';

async function fetchUser() {
    const response = await web.get('auth/user');
    return response.data;
}

export { fetchUser };
